import React, { useContext } from 'react'
import { Queue, Template } from '@chilipiper/api-type-def'
import { useTranslations, t } from '@chilipiper/locale'
import { bookingContext } from '../context/bookingContext'
import { BookWithHeader } from './BookWithHeader'
import { GroupBookWithHeader } from './GroupBookWithHeader'

interface Props {
  assigneeId?: string
  assigneeName?: string
  hideBack?: boolean
  isRescheduling?: boolean
  onBack?: () => void
  queue?: Queue
  showBack?: boolean
  template?: Template
}

export const BookWith = ({
  queue,
  template,
  assigneeId,
  onBack,
  hideBack,
  showBack,
  assigneeName,
  isRescheduling,
}: Props) => {
  const [teamMember] = useTranslations(['teamMember'])
  const { bookingState: { organizationName = '' } = {} } = useContext(bookingContext)
  const hideAssignee = !assigneeId || !!(queue?.enableBroadReschedule && isRescheduling)
  const isGroupBooking =
    queue && !hideAssignee && (queue?.algorithm === 'Group' || queue?.algorithm === 'Sequential')

  if (isGroupBooking) {
    return (
      <GroupBookWithHeader
        isReschedule={isRescheduling}
        queue={queue}
        templateName={template?.name}
        showBack={showBack}
      />
    )
  }

  const assignee =
    queue && hideAssignee && organizationName
      ? t(teamMember, { team: organizationName })
      : assigneeName

  return (
    <BookWithHeader
      isQueue={Boolean(queue)}
      hideAssignee={hideAssignee}
      showBack={showBack}
      onBack={onBack}
      hideBack={hideBack}
      assigneeName={assignee}
      isReschedule={isRescheduling}
      assigneeId={assigneeId}
      templateName={template?.name}
      meetingApprovalFlow={template?.meetingApprovalFlow}
    />
  )
}
